var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 30,
    viewBox: "0 0 19 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6137 15L17.623 8.99063L18.8623 7.75137C19.0451 7.56855 19.0451 7.27148 18.8623 7.08867L17.5363 5.7627C17.3535 5.57988 17.0564 5.57988 16.8736 5.7627L9.625 13.0113L2.37637 5.76211C2.19355 5.5793 1.89648 5.5793 1.71367 5.76211L0.387109 7.08809C0.204297 7.2709 0.204297 7.56797 0.387109 7.75078L7.63633 15L0.387109 22.2486C0.204297 22.4314 0.204297 22.7285 0.387109 22.9113L1.71309 24.2373C1.8959 24.4201 2.19297 24.4201 2.37578 24.2373L9.625 16.9887L15.6344 22.998L16.8736 24.2373C17.0564 24.4201 17.3535 24.4201 17.5363 24.2373L18.8623 22.9113C19.0451 22.7285 19.0451 22.4314 18.8623 22.2486L11.6137 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.bdc66f31edee2c9dcdad0cd3d849b49e.svg";
export { ForwardRef as ReactComponent };